import React, { useState } from 'react';
import { FiMenu, FiX } from 'react-icons/fi';
import napis from '../assets/demo/optimized/napis.webp';
import watermark from '../assets/demo/WATERMARK.png';
import { navLinks } from '../data/portfolio';

const Header = () => {
  const [isOpen, setIsOpen] = useState(false);

  const handleNavigate = () => {
    setIsOpen(false);
  };

  return (
    <header className='fixed left-0 top-0 z-50 w-full border-b border-white/5 bg-primary/90 backdrop-blur'>
      <div className='mx-auto flex h-20 max-w-[1200px] items-center justify-between px-4 sm:px-6 lg:px-8'>
        <a
          href='#home'
          className='flex min-w-0 items-center gap-2 sm:gap-3'
          aria-label='Action Fifi home'
        >
          <img
            className='h-11 w-auto shrink-0 object-contain sm:h-14'
            src={watermark}
            alt=''
            aria-hidden='true'
          />
          <img
            className='h-7 w-auto min-w-0 max-w-[140px] object-contain sm:h-10 sm:max-w-[190px]'
            src={napis}
            alt='Action Fifi'
          />
        </a>

        <nav className='hidden items-center gap-8 xl:flex'>
          {navLinks.map((link) => (
            <a
              key={link.href}
              href={link.href}
              className='text-sm font-medium text-white/75 transition hover:text-accent'
            >
              {link.label}
            </a>
          ))}
          <a href='#contact' className='pill-button h-[46px] px-6'>
            Book me
          </a>
        </nav>

        <button
          className='icon-button xl:hidden'
          type='button'
          aria-label={isOpen ? 'Close menu' : 'Open menu'}
          onClick={() => setIsOpen((value) => !value)}
        >
          {isOpen ? <FiX size={22} /> : <FiMenu size={22} />}
        </button>
      </div>

      {isOpen && (
        <div className='border-t border-white/10 bg-primary xl:hidden'>
          <nav className='mx-auto flex max-w-[1200px] flex-wrap justify-center gap-3 px-4 py-6 sm:px-6 lg:px-8'>
            {navLinks.map((link) => (
              <a
                key={link.href}
                href={link.href}
                className='rounded-full border border-white/10 bg-panel px-5 py-2 text-sm text-white/90 shadow-sm transition hover:bg-accent hover:text-primary'
                onClick={handleNavigate}
              >
                {link.label}
              </a>
            ))}
            <a
              href='#contact'
              className='rounded-full border border-accent px-5 py-2 text-sm font-semibold text-accent shadow-sm transition hover:bg-accent hover:text-primary'
              onClick={handleNavigate}
            >
              Book me
            </a>
          </nav>
        </div>
      )}
    </header>
  );
};

export default Header;
